import React, { useEffect } from 'react'

import { Box, useMediaQuery, useTheme } from '@material-ui/core'

import {
    useMainContext,
    useQuery,
    useUpdateCustomer,
    useTrackerContext,
} from 'src/hooks'

import { formatCurrency, formatStartDate, onlyNumbers } from 'src/utils'

import { SubmitWhatsAppAccept } from 'src/components/whatsapp-accept/WhatsAppAccept'
import { ConfimedOrder } from './ConfimedOrder'
import { NextStep } from './NextStep'
import { SuccessText } from 'src/components/'
import { useHistory } from 'react-router-dom'
import comboHelper from '../../utils/combo-helper'

const Success = () => {
    const history = useHistory()
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('sm'))

    const query = useQuery()

    const { mutateAsync: updateCustomer } = useUpdateCustomer()

    const barCode = query.get('code') || ''
    const bankSlipUrl = query.get('url') || ''

    const {
        buyer,
        data,
        productSelected,
        comboVariant,
        comboFlag,
        setProductSelectValue,
        goToRoute,
        isSanarPlus,
    } = useMainContext()

    const startDate = isSanarPlus
        ? formatStartDate(new Date().toISOString())
        : data?.courseClasses?.[0]?.startDate &&
          formatStartDate(data.courseClasses[0].startDate)

    const valueFirstInstallmentFormatted = formatCurrency.format(
        productSelected?.priceFirstInstallment || 0
    )

    const { track } = useTrackerContext()

    useEffect(() => {
        if (!!data?.id) {
            track({
                eventName: 'Purchase completed',
                additionalAttrs: {
                    'Payment method': buyer?.paymentMethod,
                    'Course name': data?.name,
                    'Course duration': `${data?.duration} meses`,
                    Cupom: data?.coupon?.promoCode,
                },
            })
        }
    }, [
        track,
        data?.name,
        data?.id,
        data?.duration,
        buyer?.paymentMethod,
        data?.coupon?.promoCode,
    ])

    const handleSubmitCustomer: SubmitWhatsAppAccept = (values) => {
        return updateCustomer({
            phone: values?.phone
                ? `${values.countryCode} ${onlyNumbers(values?.phone)}`
                : undefined,
            whatsAppAccept: values?.acceptWhatsapp,
            email: buyer?.email!,
        })
    }

    const next = comboVariant.find((combo) =>
        history.location.pathname.includes(combo?.current?.slug)
    )?.next

    const isCurrentCourseInCombo = comboHelper(
        comboVariant
    ).uniqueCourses?.some((course) =>
        history.location.pathname.includes(course)
    )

    const goToComboCheckout = () => {
        setProductSelectValue('')
        goToRoute(`/${next?.slug}/`)
    }

    const confirmationTitle = isSanarPlus
        ? 'Boas vindas ao Sanar+'
        : 'Quase lá!'
    const title = isSanarPlus
        ? 'Seu pagamento foi concluído! Você receberá um email de confirmação do pagamento e outro para acessar a plataforma.'
        : 'Estamos processando seu método de pagamento e em breve você estará matriculado.'

    const subtitle = isSanarPlus ? (
        <>
            Caso não tenha recebido o email de acesso,{' '}
            <a
                rel="noreferrer"
                target="_blank"
                href="https://conta.sanar.com.br/v1/recuperar-senha/solicitar?app_id=5hgds794osqi183oo50fniicna"
            >
                redefina sua senha
            </a>{' '}
            ou{' '}
            <a
                rel="noreferrer"
                target="_blank"
                href="https://wa.me/558181410811"
            >
                entre em contato conosco
            </a>
            .
        </>
    ) : (
        'Confira abaixo o status do seu pedido e os próximos passos. Aproveite também e habilite seu WhatsApp para já começar a receber informações sobre o seu curso.'
    )

    return (
        <Box mb={{ xs: 8, md: 15 }}>
            <SuccessText
                confirmationTitle={confirmationTitle}
                buyer={buyer}
                matches={matches}
                onSubmit={handleSubmitCustomer}
                title={title}
                subtitle={subtitle}
                shouldShowComboBanner={comboFlag && isCurrentCourseInCombo}
                goToComboCheckout={goToComboCheckout}
                next={next}
            />

            <ConfimedOrder
                barCode={barCode}
                bankSlipUrl={bankSlipUrl}
                matches={matches}
                name={data?.name}
                duration={data?.duration || 0}
                startDate={startDate}
                praticalWorkload={data?.practicalWorkload}
                eadWorkload={data?.eadWorkload || 0}
                value={formatCurrency.format(
                    productSelected?.installmentPrice!
                )}
                valueFirstInstallmentFormatted={valueFirstInstallmentFormatted}
            />

            {!isSanarPlus && (
                <NextStep matches={matches} startDate={startDate} />
            )}
        </Box>
    )
}

export default Success
